import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchMemberSearch } from '../../actions/project_actions';

class MemberSearch extends React.Component {
  // static PropTypes = {
  //   onAdd: PropTypes.func.isRequired,
  //   results: PropTypes.array.isRequired,
  //   fetchMemberSearch: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);

    this.state = {
      query: ''
    }

    this.timerId = 0;
    this.handleSearch = this.handleSearch.bind(this);
    this.addHandler = this.addHandler.bind(this);
  }

  handleSearch (e) {
    this.setState({query: e.target.value});

    clearTimeout(this.timerId);
    this.timerId = setTimeout(() => {
      this.props.fetchMemberSearch(this.state.query);
    }, 200);
  }

  addHandler (member) {
    return () => {
      this.setState({query: ''});
      this.props.onAdd(member);
    }
  }

  renderResults () {
    const { results } = this.props;

    return (
      <div className="results">
        <ul>
        {results.map(result =>
          <li key={result.id}>
            <strong>{result.firstName + ' ' + result.lastName}</strong>
            <span>{result.section || result.unitName}</span>
            <button className="add" onClick={this.addHandler(result)}>+</button>
          </li>
        )}
        </ul>
      </div>
    );
  }

  render () {
    const { query } = this.state;

    return (
      <div className="section-search">
        <div className="box-wrap">
          <input type="text" name="search"
            value={query}
            onChange={this.handleSearch}
            placeholder="Search for members to add ..." />
        </div>
        { query ? this.renderResults() : null }
      </div>
    )
  }
}

MemberSearch.propTypes = {
  onAdd: PropTypes.func.isRequired,
  results: PropTypes.array.isRequired,
  fetchMemberSearch: PropTypes.func.isRequired
};

function mapStateToProps (state) {
  return {
    results: state.projectsStore.memberSearchResults
  }
}

export default connect(mapStateToProps, { fetchMemberSearch })(MemberSearch);